import React, { useState } from 'react'; 
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import DateTimePickerBR from '../../components/DatePicker/datepickerbr';

import 'react-datepicker/dist/react-datepicker.css';
registerLocale('pt-BR', ptBR);

export default function Filtros({ filtros, onFilterChange, onApply }) {
  const [erroData, setErroData] = useState('');

  // const validarDatas = () => {
  //   if (filtros.inicio && filtros.fim && filtros.inicio > filtros.fim) {
  //     setErroData('A data de início não pode ser maior que a data de fim.');
  //     return false;
  //   }
  //   setErroData('');
  //   return true;
  // };

  // const aplicarFiltros = () => {
  //   if (validarDatas()) {
  //     onApply(); // Chama a função que atualiza os dados do dashboard
  //   }
  // };

  return (
    <div className="flex flex items-center gap-4 p-4">
      <label className="combo-label">Período:</label>

      <div>
        <DatePicker
          selected={filtros.inicio}
          onChange={date => onFilterChange('inicio', date)}
          dateFormat="dd/MM/yyyy"
          locale="pt-BR"
          placeholderText="Selecione"
          className="w-full p-2 border border-gray-300 rounded-md"
          isClearable
        />
      </div>
  
      <div>
        <DatePicker
          selected={filtros.fim}
          onChange={date => onFilterChange('fim', date)}
          dateFormat="dd/MM/yyyy"
          locale="pt-BR"
          placeholderText="Selecione"
          className="w-full p-2 border border-gray-300 rounded-md"
          isClearable
        />
      </div>

{/*       <div>
        <label className="block text-sm font-medium text-gray-700">Data/Hora de Início</label>
        <DateTimePickerBR selected={filtros.inicio} onChange={date => onFilterChange('inicio', date)} />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">Data/Hora Final</label>
        <DateTimePickerBR selected={filtros.fim} onChange={date => onFilterChange('fim', date)} />
      </div>
 */}



{/*       <button
        onClick={aplicarFiltros}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 color-black"
      >
        Aplicar Filtros
      </button>
 */}
      {erroData && (
        <div className="w-full text-red-600 text-sm mt-2">
          {erroData}
        </div>
      )}
    </div>
  );
}